type UploadedFileWithShareLink = {
  shareLink?: {
    token?: string | null;
  } | null;
};

export const getShareUrlFromUploadedFile = (
  uploadedFile: UploadedFileWithShareLink
) => {
  const shareToken = uploadedFile.shareLink?.token;

  if (!shareToken) {
    throw new Error("Failed to get file share link");
  }

  return `${window._env_.BACKEND_BASE_URL.replace(/\/$/, "")}/share/${shareToken}`;
};
